import moment from 'moment';
import { EmeraldErrorModal } from 'src/common/api/emerald-error';
import { showEmeraldSelectionDialog } from 'src/common/components/interactive-dialogue/components/selection-dialogue/selection-dialog';
import { SelectListItem } from 'src/common/components/select-list/select-list';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { TransactionOptionsModalCommands } from 'src/common/enumerations/tbr-enums';
import { LocalStorage } from 'src/common/helpers/local-storage';
import { IDataInformation } from 'src/common/interfaces/dtos/IDataInformation';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { ISelectionModal } from 'src/common/interfaces/dtos/ISelectionModal';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { store } from 'src/common/redux/configure-store';
import { TransactionSearchActions } from 'src/common/redux/reducers/transaction-search-reducer';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { getTBRReturnPolicy } from 'src/return-services-display/business-logic/return-transaction';
import {
  DateRange,
  ReturnPolicyResponse,
} from '../interfaces/get-effective-return-policy-response';
import { createNewDateRange } from './date-range-helper';
import { searchTransactionByCode } from '../business-logic/handle-transaction-search';
import { TransactionSearchContext } from 'src/common/interfaces/states/ITransactionSearchState';

const TRANSACTION_OPTIONS_MODAL = 'TRANSACTION_OPTIONS_MODAL';

export const transactionOptionsModal = (
  inputData: IItemInputData,
  dataInformation: IDataInformation,
  tenderExchange: boolean,
): void => {
  const transactionIdExists = store.getState().transaction.transactionIdExists;
  if (transactionIdExists) {
    throw new EmeraldErrorModal(transactionInPlaceErrorModal);
  }

  const onAccept = (data: string): void => {
    handleTransactionOptions(data, inputData, dataInformation);
  };

  const transactionOptions: SelectListItem[] = [
    {
      id: TransactionOptionsModalCommands.TransactionBasedReturn,
      description: 'TransactionBasedReturnCommand',
    },
    // Note: removing these until they are implemented
    // {
    //   id: TransactionOptionsModalCommands.ReturnAll,
    // },
    {
      id: TransactionOptionsModalCommands.Reprint,
      description: 'ReprintCommand',
    },
    // {
    //   id: TransactionOptionsModalCommands.GiftReceipt,
    // },
  ];

  const tenderExchangeOptions: SelectListItem[] = [
    {
      id: TransactionOptionsModalCommands.Reprint,
      description: 'ReprintCommand',
    },
  ];

  const modalProps: ISelectionModal = {
    message: 'HeaderControl_TransactionOptions',
    subMessage: 'TransactionOptions_Error',
    onAccept,
    onCancel: () => {
      popEmeraldModal(TRANSACTION_OPTIONS_MODAL);
    },
    selectListItems: tenderExchange ? tenderExchangeOptions : transactionOptions,
    disableBackdropClick: true,
    acceptLabel: 'Confirm',
    dataTestId: 'transaction-options',
  };

  showEmeraldSelectionDialog(modalProps, TRANSACTION_OPTIONS_MODAL);
};

const handleTransactionOptions = (
  data: string,
  barcodeInput: IItemInputData,
  dataInformation: IDataInformation,
): void => {
  if (data === TransactionOptionsModalCommands.TransactionBasedReturn && barcodeInput.itemId) {
    getTBRReturnPolicy().then((returnPolicy: ReturnPolicyResponse) => {
      const policyMaxDateRange: DateRange = {
        startDate: createNewDateRange(returnPolicy.receiptLookupPeriod),
        endDate: moment().toDate(),
      };
      store.dispatch(
        TransactionSearchActions.setSearchParam({
          dateRange: policyMaxDateRange,
          storeNumber: LocalStorage.storeId(),
          isSuspended: false,
          isVoided: false,
          searchContext: TransactionSearchContext.TBR,
        }),
      );
      if (barcodeInput.itemId) {
        searchTransactionByCode(barcodeInput.itemId, returnPolicy, dataInformation)
          .catch(popupMessage)
          .finally(() => popEmeraldModal(TRANSACTION_OPTIONS_MODAL));
      }
    });
  } else if (data === TransactionOptionsModalCommands.Reprint) {
    store.dispatch(
      TransactionSearchActions.setSearchParam({
        dateRange: {
          startDate: new Date('1970-01-01'),
          endDate: new Date(),
        },
        searchContext: TransactionSearchContext.ReprintReceipt,
      }),
    );
    if (barcodeInput.itemId) {
      searchTransactionByCode(barcodeInput.itemId)
        .catch(popupMessage)
        .finally(() => popEmeraldModal(TRANSACTION_OPTIONS_MODAL));
    }
  }
};

const transactionInPlaceErrorModal: IMessageModal = {
  type: EmeraldDialogTypes.Error,
  message: 'TransactionBarcode',
  subMessage: 'TransactionOptionsException_InTransaction',
  acceptButtonLabel: 'OK',
  hideCancelButton: true,
};
